import React from 'react';

const GreenCheck = (props) => {
    return (
<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" width="40" height="40" {...props}>
<circle cx="20" cy="20" r="20" fill="#EBFBF2"/>
<path d="M16.1 29.212C17.3167 29.7373 18.6167 30 20 30C21.3847 30.0013 22.6847 29.739 23.9 29.213C25.1153 28.687 26.1737 27.9743 27.075 27.075C27.9763 26.1757 28.6887 25.1173 29.212 23.9C29.7353 22.6827 29.998 21.3827 30 20C30.002 18.6173 29.7397 17.3173 29.213 16.1C28.6863 14.8827 27.9737 13.8243 27.075 12.925C26.1763 12.0257 25.118 11.3133 23.9 10.788C22.682 10.2627 21.382 10 20 10C18.618 10 17.318 10.2627 16.1 10.788C14.882 11.3133 13.8237 12.0257 12.925 12.925C12.0263 13.8243 11.314 14.8827 10.788 16.1C10.262 17.3173 9.99933 18.6173 10 20C10.0007 21.3827 10.2633 22.6827 10.788 23.9C11.3127 25.1173 12.025 26.1757 12.925 27.075C13.825 27.9743 14.8833 28.6867 16.1 29.212Z" fill="#3ADA7A"/>
<path d="M25.6667 16.94L17.6667 24.94L14 21.2733L14.94 20.3333L17.6667 23.0533L24.7267 16L25.6667 16.94Z" fill="white"/>
</svg>

    );
};

export default GreenCheck;
